import I18n from "i18n-js";
import React from "react";
import Colorpicker from "../../Colorpicker/Colorpicker";
import Slider from "../../Slider/Slider";
import Switch from "../../Switch/Switch";

class BookingButtonBuilderSidebar extends React.Component {
	
	constructor(props) {
		super(props);

		this.state = {
			activePanel: 'colors',
			sections: ['colors', 'position', 'size', 'style', 'advanced']
		};

		this.accordionRef = React.createRef();

		this.onChange = this.onChange.bind(this);
		this.onChangeVisible = this.onChangeVisible.bind(this);
	};
  componentDidMount() {
    $(this.accordionRef.current).find('.accordion-content[data-panel="' + this.state.activePanel + '"]').show();
  };

	componentDidUpdate(prevProps, prevState) {
		if (prevState.activePanel !== this.state.activePanel) {
			$(this.accordionRef.current).find('.accordion-content').slideUp('fast');
			$(this.accordionRef.current).find('.accordion-content[data-panel="' + this.state.activePanel + '"]').slideDown('fast');
		} else {
			$(this.accordionRef.current).find('.accordion-content[data-panel="' + this.state.activePanel + '"]').show();
		};
	};

	/**
	* Render Functions
	*/

	render() {
		var sections = this.state.sections.map((section) => {
			return this.renderAccordionSection(section);
		});

		return (
			<div ref={this.accordionRef} className="booking-button-builder-sidebar">
				{sections}
			</div>
		);
	};

	renderAccordionSection(section) {
		return (
			<div key={section}>
			  <div className={"accordion-header " + (this.state.activePanel === section ? 'open' : '')} data-for={section} onClick={(e) => this.toggleActivePanel(e)}> 
			  	<span className={this.state.activePanel === section ? 'arrow-down' : 'arrow-right'} data-for={section}>&nbsp;</span> 
			  	{I18n.t(section)}
			  </div>
			  <div className={"accordion-content " + (this.state.activePanel === section ? 'open' : '')} data-panel={section}>
			  	{this['render' + this.capitalizeFirstLetter(section)]()}
			  </div>
			</div>
		);
	};

	renderColors() {
		return (
			<div>
				<div className="form-group">
			    <label>{I18n.t('button_background_color')}</label>
			    <br />
			    <Colorpicker name="button_background_color" error={this.props.errors && this.props.errors['button_background_color']} color={this.props.button_background_color} onChange={this.onChange} />
			  </div>
				<div className="form-group">
			    <label>{I18n.t('button_font_color')}</label>
			    <br />
			    <Colorpicker name="button_font_color" error={this.props.errors && this.props.errors['button_font_color']} color={this.props.button_font_color} onChange={this.onChange} />
			  </div>
        <div className="form-group">
          <label>{I18n.t('widget_color')}</label>
          <br />
          <Colorpicker name="widget_default_color" error={this.props.errors && this.props.errors['widget_default_color']} color={this.props.widget_default_color} onChange={this.onChange} />
        </div>
			</div>
		);
	}

	renderPosition() {
		var options = ['bottom_left', 'bottom_right', 'top_left', 'top_right'].map((option) => {
			return <option key={option} value={option}>{I18n.t(option)}</option>
		});

		return (
			<div>
				<div className="form-group">
			    <label>{I18n.t('position')}</label>
			    <select className="form-control" name="position" value={this.props.position} onChange={this.onChange}>
			    	{options}
			    </select>
			  </div>
			</div>
		);
	}

	renderSize() {
		var options = ['small', 'medium', 'large'].map((option) => {
			return <option key={option} value={option}>{I18n.t(option)}</option>
		});
		
		return (
			<div>
				<div className="form-group">
			    <label>{I18n.t('size')}</label>
			    <select className="form-control" name="size" value={this.props.size} onChange={this.onChange}>
			    	{options}
			    </select>
			  </div>
			</div>
		);
	}

	renderStyle() {
		var options = ['button', 'tab'].map((option) => {
			return <option key={option} value={option}>{I18n.t(option)}</option>
		});
		
		return (
			<div>
				<div className="form-group">
			    <label>{I18n.t('size')}</label>
			    <select className="form-control" name="style" value={this.props.style} onChange={this.onChange}>
			    	{options}
			    </select>
			  </div>
			</div>
		);
	}

	renderAdvanced() {
		return (
			<div>
				<div className="form-group">
			    <label>{I18n.t('text')}</label>
			    <input type="text" className="form-control" name="text" value={this.props.text} onChange={this.onChange} />
			  </div>
				<div className="form-group">
			    <label>{I18n.t('rounded_corners')}</label>
			    <Slider name="rounded_corners" value={this.props.rounded_corners} max={50} onChange={this.onChange} />
			  </div>
			  <hr />
			  <p></p>
				<div className="form-group">
			    <label>{I18n.t('visible')} <span className="ss-help help" title={I18n.t('booking_button_visible_helper_text')}></span></label>
          <Switch name='visible' 
                  onText="yes" 
                  switchId="booking-button-visible-switch"
                  offText="no"
                  value={this.props.visible} 
                  onChange={this.onChangeVisible} />
			  </div>			  
			</div>
		);
	}

	/**
	* Event Handlers
	*/

	toggleActivePanel(event) {
		const activePanel = this.state.activePanel === event.target.dataset.for ? null : event.target.dataset.for;
		this.setState({activePanel: activePanel});
	}

	onChange(event) {
		this.props.onChange(event.target.name, event.target.value);
	}

	onChangeVisible(e) {
		this.onChange({
			target: {
				name: 'visible',
				value: e.target.checked
			}
		});
	}

	/**
	* Helper Functions
	*/

 	capitalizeFirstLetter(str) {
		return str.charAt(0).toUpperCase() + str.slice(1);
  }
}

export default BookingButtonBuilderSidebar